import { render, staticRenderFns } from "./GiftSave.vue?vue&type=template&id=def0760e&scoped=true"
import script from "./GiftSave.vue?vue&type=script&lang=js"
export * from "./GiftSave.vue?vue&type=script&lang=js"
import style0 from "./GiftSave.vue?vue&type=style&index=0&id=def0760e&prod&lang=scss&scoped=true"
import style1 from "./GiftSave.vue?vue&type=style&index=1&id=def0760e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def0760e",
  null
  
)

export default component.exports